import { useTranslation } from "react-i18next";
import { AppNewInput } from "../../../../../../shared/components/AppNewInput";
import { TDataFile, TUploadFileMethod } from "../../../../types";
import { normalizeFileExtension } from "../../../../../../shared/utils/normalizeFileExtension";
import styles from "./styles.module.css";

interface Props {
  dataType: TUploadFileMethod;
  handleFileDataChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: "file_name" | "url" | "base64_content",
    id: string,
  ) => void;
  fileData: TDataFile[];
}

export const UploadFileData = ({
  dataType,
  handleFileDataChange,
  fileData,
}: Props) => {
  const { t } = useTranslation();

  const placeholder =
    dataType === "url"
      ? t("userfiles.url_placeholder")
      : t("userfiles.base64_placeholder");

  return (
    <>
      {fileData.map((data) => (
        <div key={data.id} className={styles["form-container"]}>
          {dataType === "url" && (
            <AppNewInput
              value={data.url ?? ""}
              onChange={(e) => handleFileDataChange(e, "url", data.id)}
              placeholder={placeholder}
            />
          )}
          <AppNewInput
            value={normalizeFileExtension(data.file_name)}
            onChange={(e) => handleFileDataChange(e, "file_name", data.id)}
            placeholder={t("userfiles.filename_placeholder")}
          />
        </div>
      ))}
    </>
  );
};
